import styled from 'styled-components';
import { Modal, ModalProps } from 'antd';

export default styled(Modal)<ModalProps>`
  & .ant-modal-content {
    border-radius: 8px;
    & .ant-modal-header {
      padding: 0px 24px;
      height: 64px;
      border: none;
      border-radius: 8px 8px 0 0;
      display: flex;
      align-items: center;
      & .ant-modal-title {
        font-size: 18px;
        letter-spacing: 0;
        line-height: 27px;
        color: var(--black);
        font-weight: 400;
        width: 100%;
      }
    }
    & .ant-modal-body {
      padding: 0px;
    }
    & .ant-modal-footer {
      display: flex;
      justify-content: flex-end;
      padding: 16px 32px 24px 32px;
      border-top: 1px solid rgba(0, 0, 0, 0.05);
    }
  }
`;

export const ButtonStyled = styled.button`
  cursor: pointer;
  &.button-primary {
    margin-left: 16px;
    height: 40px;
    width: 160px;
    border-radius: 4px;
    background: linear-gradient(149.45deg, #3c82c0 0%, var(--border-color-base) 100%);
    border: none;
    outline: none;
    & .button-label {
      color: var(--white);
      font-size: 14px;
      letter-spacing: 0;
      line-height: 21px;
      text-align: center;
      font-weight: 600;
    }
  }
  &.button-secondary {
    box-sizing: border-box;
    height: 40px;
    width: 160px;
    border: 1px solid var(--border-color-base);
    border-radius: 4px;
    background-color: var(--white);
    & .button-label {
      color: var(--border-color-base);
      font-size: 14px;
      letter-spacing: 0;
      line-height: 21px;
      text-align: center;
      font-weight: 600;
    }
  }
`;
